import { Routes } from '@angular/router';
import { UniversityShellComponent } from './university-shell/university-shell.component';
import { UndergraduateProfileComponent } from './views/undergraduate-profile/undergraduate-profile.component';
import { PostgraduateProfileComponent } from './views/postgraduate-profile/postgraduate-profile.component';
import { OpenDaysComponent } from './views/open-days/open-days.component';
import { UniversityReviewsComponent } from './views/university-reviews/university-reviews.component';
import { ClearingProfileComponent } from './views/clearing-profile/clearing-profile.component';

export const UNIVERSITY_ROUTES: Routes = [
	{
		path: '',
		component: UniversityShellComponent,
		children: [
			{ path: '', component: UndergraduateProfileComponent },
			{ path: 'undergraduate', redirectTo: '', pathMatch: 'full' },
			{ path: 'postgraduate', component: PostgraduateProfileComponent },
			{ path: 'open-days', component: OpenDaysComponent },
			{ path: 'reviews', component: UniversityReviewsComponent },
		],
	},
	{ path: 'clearing', component: ClearingProfileComponent },
];
